@for (content of this.chatMessageService.messages(); track content) {
<div class="bubble" [ngClass]="{
          'right': content.role === chatRole.User,
          'system': content.role === chatRole.System,
          'stack': themeService.getChatBubbleStacked()
          }">
  @if (content.id === '0') {
    <div class="k-typing-indicator"><span></span><span></span><span></span></div>
  } @else {
    <!-- Display message card -->
    @if (content.formatted && content.formatted !== 'Processing...') {
      @if (content.role === chatRole.System && content.showExpansionPanel) {
        <!-- Expansion panel for system messages with long content -->
        <details class="system-message-expansion-panel">
          <summary class="system-message-expansion-panel-title">
            <span>{{ content.expansionPanelTitle }}</span>
          </summary>
          <div class="system-message-expansion-panel-content">
            <app-dynamic-markdown [markdownText]="content.formatted"></app-dynamic-markdown>
          </div>
          <div class="system-message-expansion-panel-footer">
            <button matIconButton type="button" class="btn-chat icon-sm" [ngClass]="{'sys': content.role === chatRole.System}"
                    #tooltip="matTooltip" aria-label="Copy response" matTooltip="Copy response" matTooltipPosition="above"
                    (click)="copyToClipboard(content.clipboardVersion!)">
              <mat-icon class="material-symbols-outlined" fontIcon="content_copy" />
            </button>
          </div>
        </details>
      } @else {
        @if (isCollapsible(content.clipboardVersion)) {
          <!-- Collapsible bubble for long messages -->
          <details class="bubble-collapse" open>
            <summary [attr.aria-label]="'Toggle message'">
              <!--
                This preview line strips all pseudo-XML blocks (e.g., <thinking>, <tool_use>, <tool_result>) from the message before truncating it for the collapsed summary.
                This ensures that only the main user/AI message is shown in the preview, not any meta or tool-use blocks.
              -->
              <span class="collapse-preview" aria-hidden="true">{{ stripPseudoXml(content.clipboardVersion ?? '') | truncateParagraph:collapsePreviewWordCount }}</span>
            </summary>
            <div class="content img-wrapper" [class.streaming-active]="content.isStreaming">
              <app-dynamic-markdown [markdownText]="content.formatted"></app-dynamic-markdown>
              @if (content.isStreaming) {
                <div class="streaming-indicator">
                  <span class="streaming-dot"></span>
                  <span class="streaming-text">Streaming...</span>
                  <button matIconButton (click)="onCancelStream(content.id)" matTooltip="Cancel streaming">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
            </div>
          </details>
        } @else {
          <div class="content img-wrapper" [class.streaming-active]="content.isStreaming">
            <app-dynamic-markdown [markdownText]="content.formatted"></app-dynamic-markdown>
            @if (content.isStreaming) {
              <div class="streaming-indicator">
                <span class="streaming-dot"></span>
                <span class="streaming-text">Streaming...</span>
                <button matIconButton (click)="onCancelStream(content.id)" matTooltip="Cancel streaming">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
      }

      @if (content.meta) {
        <div class="attachments">
          @for (document of content.meta.documents; track document) {
          <div class="attachment">
            <attachment-doc [document]="document"></attachment-doc>
          </div>
          }
        </div>
      }
    } @else {
    <!-- Display processing message -->
    <div class="processing">
      @if (automationStateService.isWorkflowInProgress() || automationStateService.isFileUploadInProgress() || automationStateService.instructionInProgress()) {
      <div class="process-notice">
        <span class="txt">Processing</span>
        <!--<mat-spinner color="primary" diameter="20"></mat-spinner>-->
        <mat-progress-bar mode="buffer" class="processing-bar"></mat-progress-bar>
      </div>
      } @else {
      <span class="txt">Processing...</span>
      <div class="workflow-wrapper">
        <button matButton="tonal" class="btn-cancel" (click)="onCancelRetries()">
          Cancel
          <mat-icon>
            <mat-spinner color="primary" diameter="20">
            </mat-spinner>
          </mat-icon>
        </button>
        @if (hasProperty(content, "progressDetail")) {
        @if (hasProperty(content.progressDetail, "workflow")) {
        <div [appMermaid]="generateMermaidDiagram(content.progressDetail.workflow)" class="workflow"></div>
        }
        }
      </div>
      }
    </div>
    }

  <!-- Display the copy button and the info button -->
  @if ((content.formatted && content.formatted !== 'Processing...') && content.formatted !== 'Welcome to CGI Federal AI Assist. Please use responsibly.') {
    <div class="btn-grp-assistant-resp">
      @if (content.role !== chatRole.User && content.role !== chatRole.System) {
      <button matIconButton type="button" class="btn-chat icon-sm" #tooltip="matTooltip" (click)="showRequestDetails(content)"
              aria-label="Get details of how this answer was generated"
              matTooltip="Get details of how this answer was generated" matTooltipPosition="above">
        <mat-icon class="material-symbols-outlined" fontIcon="info" />
      </button>
      }
      @if (content.role === chatRole.User) {
      <button matIconButton type="button" class="btn-chat icon-sm" #tooltip="matTooltip"
              aria-label="Quick add prompt to Automation Library" matTooltip="Quick add prompt to Automation Library"
              matTooltipPosition="above" (click)="quickAddPromptToPromptLibrary(content.clipboardVersion!)">
        <mat-icon class="material-symbols-outlined" fontIcon="save" />
      </button>
      }
      @if (!content.showExpansionPanel) {
      <button matIconButton type="button" class="btn-chat icon-sm" [ngClass]="{'sys': content.role === chatRole.System}"
              #tooltip="matTooltip" aria-label="Copy response" matTooltip="Copy response" matTooltipPosition="above"
              (click)="copyToClipboard(content.clipboardVersion!)">
        <mat-icon class="material-symbols-outlined" fontIcon="content_copy" />
      </button>
      }
    </div>
    }
  }
</div>
}
